<div class="flex gap-4">
  <!-- Timeline column: flex-based, no absolute positioning -->
  <div class="flex flex-col items-center shrink-0 w-6">
    <!-- Upper segment (fixed height to align dot with card header) -->
    <div
      class="h-5 shrink-0"
      [ngClass]="!isFirst ? 'w-0.5 bg-neutral-300 dark:bg-neutral-600' : ''"
    ></div>

    <!-- Dot -->
    <span
      class="h-3 w-3 rounded-full border-2 border-blue-500 bg-blue-500 ring-4 ring-blue-500/20 shrink-0"
    ></span>

    <!-- Lower segment (stretches to fill remaining height) -->
    <div
      class="flex-1 shrink-0"
      [ngClass]="!isLast ? 'w-0.5 bg-neutral-300 dark:bg-neutral-600' : ''"
    ></div>
  </div>

  <!-- Event card -->
  <div class="flex-1 pb-4 min-w-0">
    <button
      type="button"
      (click)="toggle()"
      class="w-full text-left rounded-lg border border-neutral-200 bg-white
             transition-all duration-200 hover:shadow-md hover:border-neutral-300
             dark:border-neutral-700 dark:bg-neutral-800 dark:hover:border-neutral-600
             focus:outline-none focus:ring-2 focus:ring-blue-500/30"
    >
      <!-- Header -->
      <div class="flex items-center justify-between gap-3 px-4 py-3">
        <div class="flex items-center gap-3 min-w-0 flex-1">
          <!-- System badges -->
          <div class="flex items-center gap-1.5 shrink-0">
            <span
              class="inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide
                     bg-indigo-50 text-indigo-700 ring-1 ring-inset ring-indigo-600/20
                     dark:bg-indigo-900/30 dark:text-indigo-300 dark:ring-indigo-400/30"
            >
              {{ event.eventOrigin }}
            </span>

            <svg class="h-3.5 w-3.5 text-neutral-400 dark:text-neutral-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
              <path stroke-linecap="round" stroke-linejoin="round" d="M13 7l5 5m0 0l-5 5m5-5H6" />
            </svg>

            <span
              class="inline-flex items-center rounded-md px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide
                     bg-emerald-50 text-emerald-700 ring-1 ring-inset ring-emerald-600/20
                     dark:bg-emerald-900/30 dark:text-emerald-300 dark:ring-emerald-400/30"
            >
              {{ event.eventTarget }}
            </span>
          </div>

          <!-- Event name -->
          <span class="text-sm font-medium text-neutral-700 dark:text-neutral-200 truncate">
            {{ event.description || event.name }}
          </span>
        </div>

        <div class="flex items-center gap-2 shrink-0">
          <!-- Date -->
          <span
            *ngIf="event.createdAt"
            class="text-[11px] font-medium text-neutral-500 dark:text-neutral-400 whitespace-nowrap tabular-nums"
          >
            {{ formatDate(event.createdAt) }}
          </span>

          <!-- Expand icon -->
          <svg
            class="h-4 w-4 text-neutral-400 dark:text-neutral-500 transition-transform duration-200"
            [class.rotate-180]="expanded()"
            fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2"
          >
            <path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
    </button>

    <!-- Expandable content -->
    <div
      *ngIf="expanded()"
      class="mt-1 rounded-lg border border-neutral-200 bg-neutral-50
             dark:border-neutral-700 dark:bg-neutral-900 overflow-hidden"
    >
      <div class="flex items-center justify-between px-4 py-2 border-b border-neutral-200 dark:border-neutral-700 bg-neutral-100 dark:bg-neutral-800/50">
        <span class="text-[11px] font-semibold uppercase tracking-wider text-neutral-500 dark:text-neutral-400">
          Payload (data)
        </span>
      </div>
      <pre
        class="p-4 text-xs text-neutral-700 dark:text-neutral-300 overflow-auto max-h-80
               whitespace-pre-wrap break-words font-mono leading-relaxed"
      >{{ formatJson(event.data) }}</pre>
    </div>
  </div>
</div>
